module.exports = __webpack_public_path__ + "static/media/powerbi_logo.e2a77d18.png";